let settings;
const defaults = {
	container: 'g-map',
	mapSettings: {
		mapContainer: '.map',
		zoomControls: true,
		center: [-3.70379, 40.416775], // starting position [lng, lat]
		zoom: 14, // starting zooms
		minZoom: 4,
		maxZoom: 10,
		maxBounds: [
			[-28, 25],
			[22, 52]
		],
		disableScrollZoom: false,
		createFlytoCanariasButton: false
	},
	fullScreen: false,
	hash: false,
	geocoder: {
		show: true,
		type: 'place',
		position: 'top-right'
	},
	jsonFiles: {
		url: ''
	},
	csvFiles: {
		url: ''
	},
	spinnerLoader: true,
	hover: true,
	hoverBlockedRight: true,
	attributionControl: false,
	createLegend: false,
	createScaleBar: true
};

function deepMerge(target, source) {
	const output = Object.assign({}, target);
	for (const key in source) {
		if (Object.prototype.hasOwnProperty.call(source, key)) {
			if (isObject(source[key]) && isObject(target[key])) {
				output[key] = deepMerge(target[key], source[key]);
			} else {
				output[key] = source[key];
			}
		}
	}
	return output;
}

function isObject(item) {
	return item && typeof item === 'object' && !Array.isArray(item);
}

export default class Settings {
	constructor(opts) {
		this.options = deepMerge(defaults, opts);

		this.getSettings = () => this.options;

		this.set = (obj) => {
			const key = Object.keys(obj).slice().pop();
			const value = Object.values(obj).slice().pop();
			this.options[key] = value;
		};

		this.get = (key) => {
			return this.options[key];
		};

		// this.getmapboxConfiguration = () => {
		//   return mapboxConfiguration;
		// };
	}
}
